import { useMutation } from "@tanstack/react-query";
import React from "react";
import { changePassword } from "../../../services/ProfileService";
import useForm from "../../../hooks/useForm";
import Form from "../../form/Form";
import Card from "../Card";
import Input from "../../form/Input";
import Button from "../../form/Button";
import { t } from "i18next";

const validation = {
  currentPassword: { required: true, message: "this field is required" },
  newPassword: { required: true, message: "this field is required" },
  confirmPassword: { required: true, message: "this field is required" },
};

const PasswordSettings = () => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    formValidate,
  } = useForm({ validationRules: validation });

  const { mutate: onSubmit, isPending } = useMutation({
    mutationFn: async (value) => {
      const payload = {
        ...value,
      };
      return await changePassword(payload);
    },
    onSuccess: (res) => {
      console.log(res);
    },
  });
  return (
    <Form handleSubmit={handleSubmit} onSubmit={onSubmit}>
      <div className="bg-white py-4 px-4 rounded-md space-y-4">
        <div className="space-y-6">
          <Card
            title={t("Password manage")}
            bodyClass={"space-y-6"}
            className={"py-6 px-3 md:px-6"}
          >
            <Input
              inputType="password"
              onChange={handleChange}
              value={values?.currentPassword}
              label={t("Current password")}
              inputName={"currentPassword"}
              inputPlaceholder={"Enter current password"}
              {...formValidate(errors, "currentPassword")}
            />
            <Input
              inputType="password"
              onChange={handleChange}
              value={values?.newPassword}
              label={t("New password")}
              inputName={"newPassword"}
              inputPlaceholder={"Enter new password"}
              {...formValidate(errors, "newPassword")}
            />
            <Input
              inputType="password"
              onChange={handleChange}
              value={values?.confirmPassword}
              label={t("Confirm password")}
              inputName={"confirmPassword"}
              inputPlaceholder={"Enter confirm password"}
              {...formValidate(errors, "confirmPassword")}
            />
          </Card>
        </div>
        <div className="flex gap-3">
          <Button
            buttonLabel={t("Save")}
            buttonType="submit"
            {...(isPending && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
        </div>
      </div>
    </Form>
  );
};

export default PasswordSettings;
